module.exports = __webpack_public_path__ + "img/chuangye-logo.3d490e1f.png";